import { ChartMark, WidgetKind, type Report } from 'corso-admin-ui';

const anyClaimType = 'Claims of any type on the orders registered from';

export const overview = {
  key: 'overview',
  label: 'Overview',
  dataset: 'registrations',
  timeFields: ['createdOn', 'purchasedOn'],
  widgets: [
    { kind: WidgetKind.kpi, metric: 'registrations' },
    {
      kind: WidgetKind.kpi,
      metric: 'registeredProducts',
      description: "One for each line item on a registration's order",
    },
    {
      kind: WidgetKind.kpi,
      metric: 'orderClaims',
      description: anyClaimType,
    },
    {
      kind: WidgetKind.overTime,
      title: 'Registrations over time',
      mark: ChartMark.line,
      metrics: ['registrations', 'registeredProducts'],
    },
    {
      kind: WidgetKind.ranking,
      title: 'Registrations by sales channel',
      dimension: 'salesChannelName',
      metric: 'registrations',
    },
    {
      kind: WidgetKind.ranking,
      title: 'Top registered products',
      dimension: 'productTitle',
      metric: 'registeredProducts',
      limit: 10,
    },
    {
      kind: WidgetKind.ranking,
      title: 'Order claims by sales channel',
      description: anyClaimType,
      dimension: 'salesChannelName',
      metric: 'orderClaims',
    },
    {
      kind: WidgetKind.ranking,
      title: 'Top products by order claims',
      description: `${anyClaimType}, whichever of the order's products they are about`,
      dimension: 'productTitle',
      metric: 'orderClaims',
      limit: 10,
    },
  ],
} as const satisfies Report;
